module.exports = __webpack_public_path__ + "static/media/ta-grad-02.d4c831e0.png";